import React, { useEffect, useRef } from "react";
import { animate, createScope } from "animejs";

function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

export default function HeroAmbient() {
  const rootRef = useRef(null);

  useEffect(() => {
    if (!rootRef.current) return undefined;
    if (prefersReducedMotion()) return undefined;

    const scope = createScope({ root: rootRef }).add(() => {
      const targets = rootRef.current?.querySelectorAll("[data-blob]") || [];
      targets.forEach((t, i) => {
        animate(t, {
          translateX: [
            { to: 20 * (i % 2 === 0 ? 1 : -1), duration: 4200 },
            { to: -18 * (i % 2 === 0 ? 1 : -1), duration: 5200 },
          ],
          translateY: [
            { to: -14, duration: 3800 },
            { to: 18, duration: 5600 },
          ],
          scale: [
            { to: 1.06, duration: 4800 },
            { to: 0.96, duration: 5400 },
          ],
          easing: "inOutSine",
          direction: "alternate",
          loop: true,
          delay: 200 * i,
        });
      });
    });

    return () => scope.revert();
  }, []);

  return (
    <div ref={rootRef} aria-hidden="true" className="pointer-events-none absolute inset-0">
      <div
        data-blob
        className="absolute left-[-10%] top-[-20%] h-[520px] w-[520px] rounded-full bg-fk-accent/25 blur-3xl dark:bg-fk-accent2/20"
      />
      <div
        data-blob
        className="absolute right-[-12%] top-[5%] h-[520px] w-[520px] rounded-full bg-fk-accent2/18 blur-3xl dark:bg-fk-accent/18"
      />
      <div
        data-blob
        className="absolute bottom-[-25%] left-[30%] h-[520px] w-[520px] rounded-full bg-fk-ink/10 blur-3xl dark:bg-white/10"
      />
    </div>
  );
}

